const apiURI = process.env.REACT_APP_API_URL;
const SSGPBase = process.env.REACT_APP_SSGP_URL;
export {
  apiURI,
  SSGPBase,
};
